var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVippsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 22,
    viewBox: "0 0 72 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8675 8.38245C71.0586 5.32829 69.095 4.11597 66.4146 4.11597C64.2429 4.11597 61.5173 5.32829 61.5173 8.2477C61.5173 10.1338 62.8339 11.6161 64.9823 11.998L67.0154 12.357C68.4018 12.6039 68.7945 13.1206 68.7945 13.8168C68.7945 14.6027 67.9397 15.0517 66.6691 15.0517C65.0059 15.0517 63.9661 14.4679 63.8042 12.8285L60.8703 13.2777C61.3321 16.4438 64.1967 17.7466 66.7843 17.7466C69.2335 17.7466 71.8441 16.354 71.8441 13.5472C71.8441 11.6383 70.6656 10.2464 68.4708 9.84167L66.2301 9.43789C64.9823 9.21337 64.5667 8.60697 64.5667 8.02318C64.5667 7.28202 65.375 6.81086 66.4841 6.81086C67.8936 6.81086 68.8869 7.28202 68.9331 8.83148L71.8675 8.38245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64416 13.1875L9.69323 4.45262H13.2741L7.96027 17.4092H5.30372L-0.0101318 4.45287H3.57075L6.64416 13.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5788 9.9093C24.5493 9.9093 25.381 9.19076 25.381 8.15795C25.381 7.12489 24.5493 6.4066 23.5788 6.4066C22.6085 6.4066 21.7771 7.12489 21.7771 8.15795C21.7771 9.19076 22.6085 9.9093 23.5788 9.9093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9354 12.7389C24.7338 14.2655 23.4632 15.3209 21.2222 15.321C18.9355 15.321 17.1562 13.9737 15.77 11.9978C15.2154 11.1892 14.3606 11.0097 13.7367 11.4364C13.1592 11.8407 13.0209 12.6939 13.5519 13.4351C15.4694 16.2869 18.1262 17.9482 21.2219 17.9482C24.0639 17.9482 26.282 16.6012 28.0145 14.3555C28.6613 13.5249 28.6382 12.6716 28.0145 12.1999C27.4368 11.7504 26.5819 11.9083 25.9354 12.7389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9071 6.24946V4.475H30.6497V21.9005H33.9071V15.7026C34.993 17.1399 36.4023 17.7466 37.9962 17.7466C40.977 17.7466 43.8878 15.456 43.8878 10.7405C43.8878 6.2266 40.8613 4.11622 38.2735 4.11622C36.2173 4.11622 34.8083 5.03665 33.9071 6.24946ZM37.2342 14.9396C35.4782 14.9396 33.9071 13.5472 33.9071 10.8974C33.9071 8.13533 35.4782 6.90038 37.2571 6.90038C38.8974 6.90038 40.6073 8.20246 40.6073 10.8974C40.6073 13.637 38.8974 14.9396 37.2342 14.9396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.549 6.24946V4.475H46.2913V21.9005H49.5487V15.7026C50.6347 17.1399 52.0439 17.7466 53.6378 17.7466C56.6184 17.7466 59.5294 15.456 59.5294 10.7405C59.5294 6.2266 56.5029 4.11622 53.9151 4.11622C51.8589 4.11622 50.4499 5.03665 49.549 6.24946ZM52.8759 14.9396C51.1198 14.9396 49.549 13.5472 49.549 10.8974H49.5487C49.5487 8.13533 51.1198 6.90038 52.8987 6.90038C54.539 6.90038 56.2487 8.20246 56.2487 10.8974C56.2487 13.637 54.5391 14.9396 52.8759 14.9396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVippsLogo);
export default __webpack_public_path__ + "static/media/vipps-logo.7cf084960167c7ca1c0e6dd05687cb71.svg";
export { ForwardRef as ReactComponent };